module.exports = __webpack_public_path__ + "img/api_gateway.e651667b.jpg";